// Miky Motorsport - casticovy system (object pool -> InstancedMesh)
// M1a: smyk kour za zadnimi koly pri prokluzu/rucni brzde.
import * as THREE from 'three';
import { POOL } from './constants.js';

export class ParticleSystem {
  constructor(scene, max = POOL.PARTICLES) {
    this.max = max;
    const geo = new THREE.SphereGeometry(0.5, 6, 5);
    const mat = new THREE.MeshLambertMaterial({
      color: 0xe8eaf0,
      transparent: true,
      opacity: 0.46,
      depthWrite: false,
    });
    this.mesh = new THREE.InstancedMesh(geo, mat, max);
    this.mesh.frustumCulled = false;
    this.mesh.instanceMatrix.setUsage(THREE.DynamicDrawUsage);
    this.mesh.castShadow = false;
    this.mesh.receiveShadow = false;
    scene.add(this.mesh);

    this._dummy = new THREE.Object3D();
    this.pool = new Array(max);
    for (let i = 0; i < max; i++) {
      this.pool[i] = { active: false, x: 0, y: 0, z: 0, vx: 0, vy: 0, vz: 0, life: 0, maxLife: 1, size: 1 };
      this._dummy.position.set(0, -9999, 0);
      this._dummy.scale.setScalar(0.0001);
      this._dummy.updateMatrix();
      this.mesh.setMatrixAt(i, this._dummy.matrix);
    }
    this.mesh.instanceMatrix.needsUpdate = true;
    this._cursor = 0;
  }

  spawnSmoke(x, y, z, strength = 1) {
    // najdi neaktivni (round-robin od cursoru)
    for (let n = 0; n < this.max; n++) {
      const i = (this._cursor + n) % this.max;
      const p = this.pool[i];
      if (!p.active) {
        p.active = true;
        p.x = x + (Math.random() - 0.5) * 0.3;
        p.y = y + 0.1;
        p.z = z + (Math.random() - 0.5) * 0.3;
        p.vx = (Math.random() - 0.5) * 0.6;
        p.vy = 0.4 + Math.random() * 0.5;
        p.vz = (Math.random() - 0.5) * 0.6;
        p.maxLife = 0.5 + Math.random() * 0.5;
        p.life = p.maxLife;
        p.size = (0.4 + Math.random() * 0.4) * (0.6 + strength * 0.6);
        this._cursor = (i + 1) % this.max;
        return;
      }
    }
  }

  update(dt) {
    for (let i = 0; i < this.max; i++) {
      const p = this.pool[i];
      if (!p.active) continue;
      p.x += p.vx * dt;
      p.y += p.vy * dt;
      p.z += p.vz * dt;
      p.vy *= 0.94;
      p.vx *= 0.92;
      p.vz *= 0.92;
      p.life -= dt;
      if (p.life <= 0) p.active = false;
    }
  }

  // zapis instancnich matic (volat v render)
  writeInstances() {
    for (let i = 0; i < this.max; i++) {
      const p = this.pool[i];
      if (!p.active) {
        this._dummy.position.set(0, -9999, 0);
        this._dummy.scale.setScalar(0.0001);
      } else {
        const t = p.life / p.maxLife; // 1 -> 0
        const grow = (1 - t) * 1.6 + 0.4; // kour roste jak se rozplyva
        this._dummy.position.set(p.x, p.y, p.z);
        this._dummy.scale.setScalar(p.size * grow);
      }
      this._dummy.updateMatrix();
      this.mesh.setMatrixAt(i, this._dummy.matrix);
    }
    this.mesh.instanceMatrix.needsUpdate = true;
  }

  dispose() {
    this.mesh.geometry.dispose();
    this.mesh.material.dispose();
    if (this.mesh.parent) this.mesh.parent.remove(this.mesh);
  }
}
